import React from "react"
import styled from "styled-components/macro"
import colors from "../../scripts/colors"
import Icon from "../../images/iconmonstr-arrow-24---outline.svg"
import "@fontsource/noto-sans-jp/900.css"

const SectionHeaderStyles = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto 27px;
  h3 {
    margin: 0 0 27px;
    font-size: 40px;
    font-weight: 900;
    line-height: 1em;
  }
  @media screen and (min-width: 790px) {
    h3 {
      font-size: 50px;
    }
  }
`

const SectionTitleDecoration = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

const SectionTitleLine = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 3px;
  width: 100%;
  background-color: ${colors("grey", "xlt")};
`

const SectionTitleIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  /* transform: rotate(90deg); */
  height: 27px;
  color: ${colors("purple")};
`

const SectionHeader: React.FC = ({ children }) => {
  return (
    <SectionHeaderStyles>
      <h3>{children}</h3>
      <SectionTitleDecoration>
        <SectionTitleLine></SectionTitleLine>
        <SectionTitleIcon>
          <Icon />
        </SectionTitleIcon>
      </SectionTitleDecoration>
    </SectionHeaderStyles>
  )
}

export default SectionHeader
